// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._5ljs364fx{background-color:rgba(0,0,0,0.25);width:100%;position:absolute;height:100%;z-index:2}._6CY9PqIJx{flex:1 0 auto;position:relative;width:100%;display:flex;flex-direction:row;align-items:stretch;z-index:1}._7sybDaL4x{display:flex;height:100%}._2iE3S2vCx{display:flex;flex-direction:column;width:50px;background-color:var(--gray-light3);position:absolute;height:100%;transition:width 300ms cubic-bezier(0.215, 0.61, 0.355, 1);z-index:2}@media (min-width: 1300px){._2iE3S2vCx{height:auto}}@media (max-width: 767px){html[data-supports-mobile=true] ._2iE3S2vCx{top:0;transition:transform 300ms cubic-bezier(0.215, 0.61, 0.355, 1);transform:translateX(-260px);width:260px}}@media screen and (-ms-high-contrast: active){._2iE3S2vCx{border-right:1px solid windowText;box-sizing:border-box}}._2iE3S2vCx::after{position:absolute;content:'';top:0;right:-1px;height:100%;box-shadow:0 0 5px 0 rgba(0,0,0,0.02);width:1px}@media (min-width: 1300px){._2iE3S2vCx{position:relative}}._2iE3S2vCx._6BswY6yRx{display:none}._2iE3S2vCx._1YtINXJbx{background-color:var(--gray-8);box-shadow:1px 0 0 var(--box-shadow)}@media screen and (-ms-high-contrast: active){._2iE3S2vCx._1YtINXJbx{box-shadow:0 1px 0 0 buttonText}}._2iE3S2vCx._7GPvpcLwx{width:260px;z-index:3}@media (min-width: 1300px){._2iE3S2vCx._7GPvpcLwx{z-index:2}}@media (max-width: 767px){html[data-supports-mobile=true] ._2iE3S2vCx._7GPvpcLwx{transform:translateX(0)}}._2mds4mzyx{flex-grow:1;display:block;margin-left:50px;position:relative;overflow:hidden}@media (min-width: 1300px){._2mds4mzyx{margin-left:0}}@media (max-width: 767px){html[data-supports-mobile=true] ._2mds4mzyx{margin-left:0}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"small-window-expanded-nav-overlay": "_5ljs364fx",
	"smallWindowExpandedNavOverlay": "_5ljs364fx",
	"shell": "_6CY9PqIJx",
	"app-not-found-container": "_7sybDaL4x",
	"appNotFoundContainer": "_7sybDaL4x",
	"left-nav-container": "_2iE3S2vCx",
	"leftNavContainer": "_2iE3S2vCx",
	"hidden": "_6BswY6yRx",
	"new-nav": "_1YtINXJbx",
	"newNav": "_1YtINXJbx",
	"expanded": "_7GPvpcLwx",
	"view-port": "_2mds4mzyx",
	"viewPort": "_2mds4mzyx"
};
module.exports = exports;
